import React from 'react'

import { LntImage } from '@app/components/base'
import { LabelValueTable } from '@app/components'

import barcode from '@app/assets/images/barcode.svg'

import { generateTableItems } from '@app/pages/ProcessingResultsPageInner/lib'

import { titlesMap, targetKeys } from './configs'

import styles from './styles.module.scss'

import type { ProductCharacteristicsProps } from './types'

export const ProductCharacteristics: React.FC<ProductCharacteristicsProps> = ({ data }) => {
  const productData = generateTableItems({
    data,
    titlesMap,
    targetKeys
  })

  return (
    <div className={ styles.productCharacteristics }>
      <h5 className={ styles.productCharacteristics__title }>О товаре</h5>

      <LabelValueTable
        hasSeparator
        columns={ 2 }
        data={ productData }
      />

      <div className={ styles.productCharacteristics__barcodes }>
        <LntImage
          src={ barcode }
          preview={ false }
          width={ 20 }
          height={ 12 }
          alt='Штрих-код'
          title='Штрих-код'
        />
        <span>{ data?.barcodes }</span>
      </div>
    </div>
  )
}
